module.exports = __webpack_public_path__ + "img/icon-warning.cc9a8146.svg";